<div class="trinka_cloud_wrap">
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>抄襲檢查工具</h1>
                        <h2>避免抄襲和檢測AI生成的內容</h2>
                        <ul class="highted-points">
                            <li>使用備受信賴的iThenticate報告檢查付費出版論文的抄襲</li>
                            <li>檢測任何文檔中AI生成的內容</li>
                            <li>獲得免費抄襲檢查以及重複內容來源報告</li>
                        </ul>
                        <a href="https://cloud.trinka.ai/signup" id="autoEditGetStart" target="_blank">開始使用</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mainSliderSection text-center">
                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="../../../../../assets/images/plagiarism-check/plagiarism-check.jpg">
                            <source src="../../../../../assets/images/plagiarism-check/plagiarism-check.mp4#t=0.1" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                        <button class="icon-pause" (click)="playPause()" [ngClass]="video_pause ? 'icon-play' : 'icon-pause'"> </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="section-lg trustedby">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h3>全球領導者信賴的選擇</h3>
            </div>
            <div class="col-12">
                <div id="client-logos_white" class="owl-carousel">
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/elsevier.svg" class="filter" alt="elsevier">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/mit.svg" class="filter" alt="mit">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/IEEE.svg" class="filter" alt="IEEE">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/stanford.svg"  class="filter" alt="standord">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/wiley.svg" class="filter" alt="wiley">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/harvard-white.svg" alt="harvard">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/caltech.svg" class="filter" alt="caltech">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/mu.svg" class="filter" alt="mu">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/polyglots.png" class="img-fluid" alt="polyglots">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/pfizer.svg" class="filter" alt="pfizer">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/abbott.svg" class="filter" alt="abbott">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/princeton-white.svg" alt="princeton">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="writing_need_sections section-lg">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-tl">
                    <h2>找到最適合您的抄襲檢查工具</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="standout-tbl">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>對比文本/特點</th>
                                    <th>
                                        免費點數<br/>
                                        <p class="powered-by"><span>技術提供</span> <img src="../../../../../assets/images/plagiarism-check/iThenticate_logo.svg" class="iThenticate-logo" width="90" alt="iThenticate" /></p>
                                    </th>
                                    <th>標準抄襲檢查
                                    </th>
                                    <th>高級抄襲檢查<br/>
                                        <p class="powered-by"><span>技術提供</span> <img src="../../../../../assets/images/plagiarism-check/iThenticate_logo.svg" class="iThenticate-logo" width="90" alt="iThenticate" /></p>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- <tr>
                                    <td>AI生成內容檢測器 <span class="newbadge">全新</span></td>
                                    <td>-</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                </tr> -->
                                <tr>
                                    <td>8900萬付費學術文章</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>990億個當前和已歸檔的網頁</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>2億個開放獲取文章</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>每日搜索更新1.02億個網頁</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>互動式報告，可下載PDF</td>
                                    <td>-</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="single-wrapper section-md">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="wrap-content">
                    <h3>訂閱<span>Trinka高級Plus</span>，取得無限存取標準抄襲報告</h3>
                    <a [routerLink]="['/pricing']" routerLinkActive="active" class="btn-outline-enago">
                        <span>瞭解更多</span> <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path d="M12.5248 15.6833C12.3664 15.6833 12.2081 15.625 12.0831 15.5C11.8414 15.2583 11.8414 14.8583 12.0831 14.6166L16.6998 9.99998L12.0831 5.38331C11.8414 5.14164 11.8414 4.74164 12.0831 4.49998C12.3248 4.25831 12.7248 4.25831 12.9664 4.49998L18.0248 9.55831C18.2664 9.79998 18.2664 10.2 18.0248 10.4416L12.9664 15.5C12.8414 15.625 12.6831 15.6833 12.5248 15.6833Z" fill="black"/>
                            <path d="M17.4415 10.625H3.4165C3.07484 10.625 2.7915 10.3417 2.7915 10C2.7915 9.65833 3.07484 9.375 3.4165 9.375H17.4415C17.7832 9.375 18.0665 9.65833 18.0665 10C18.0665 10.3417 17.7832 10.625 17.4415 10.625Z" fill="black"/>
                          </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="plagCheckKeyFeatures section-lg">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-tl">
                    <h2>主要特點</h2>
                    <div class="HeadingSubLine"></div>
                </div>
                <div class="tabs-wrap">
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="pill" href="#freeScore">
                                <span>免費點數</span>
                                <div class="poweredBy">
                                    <img src="../../../../assets/images/plagiarism-check/iThenticate_logo.svg" width="115" class="iThenticate-logo" alt="iThenticate_logo" />
                                </div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="pill" href="#standardPlagiarism">
                                <span>標準抄襲檢查</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link " data-toggle="pill" href="#advancedPlagiarism">
                                <span>高級抄襲檢查</span>
                                <div class="poweredBy">
                                    <img src="../../../../assets/images/plagiarism-check/iThenticate_logo.svg" width="115" class="iThenticate-logo" alt="iThenticate_logo" />
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content">
                    <div id="freeScore" class="tab-pane active">
                        <div class="pc-para">
                            <span>檢查互聯網來源並檢測AI生成的內容</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6">
                                <div class="c-card key-features-left">
                                    <div id="accordion_free" class="accordion">
                                        <div class="card" [ngClass]="freeshowTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="freeScore(1)" data-toggle="collapse" href="#freecollapseOne">
                                                    <span><img src="../../../../assets/images/plagiarism-check/text-block.svg" alt="icon" /></span>
                                                    前3個匹配來源
                                                </a>
                                            </div>
                                            <div id="freecollapseOne" class="collapse show" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>列出前3個匹配的來源以及匹配百分比。</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="freeshowTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="freeScore(2)" data-toggle="collapse" href="#freecollapseTwo">
                                                    <span><img src="../../../../assets/images/plagiarism-check/sources.svg" alt="icon" /></span>
                                                    顯示總體相似度積分
                                                </a>
                                            </div>
                                            <div id="freecollapseTwo" class="collapse" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>根據檢測到的抄襲問題，將獲得文章內容相似度分數。</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="freeshowTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="freeScore(3)" data-toggle="collapse" href="#freecollapseThree">
                                                    <span><img src="../../../../assets/images/plagiarism-check/text-block.svg" alt="icon" /></span>
                                                    互聯網匹配和付費出版物分數
                                                </a>
                                            </div>
                                            <div id="freecollapseThree" class="collapse" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>文檔顯示互聯網和付費來源的各別分數。</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="c-card key-features-right">
                                    <div class="image" [ngClass]="freeshowTab == 1 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/matching-scroe.svg" alt="matching-score" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="freeshowTab == 2 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/overall-score.svg" alt="overall-score" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="freeshowTab == 3 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/overall-paid.svg" alt="overall-paid" class="flags hidden" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="standardPlagiarism" class="tab-pane">
                        <div class="pc-para">
                            <span>檢查互聯網來源並檢測AI生成的內容</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6">
                                <div class="c-card key-features-left">
                                    <div id="accordion_standard" class="accordion">
                                        <!-- <div class="card" [ngClass]="standardshowTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="standardPlagiarism(1)" data-toggle="collapse" href="#standardcollapseOne">
                                                    <span><img src="../../../../assets/images/plagiarism-check/cpu-charge.svg" alt="icon" /></span>
                                                    AI生成內容檢測器
                                                </a>
                                            </div>
                                            <div id="standardcollapseOne" class="collapse show" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>檢測由大型語言模型（如ChatGPT）生成的內容。</p>
                                                </div>
                                            </div>
                                        </div> -->
                                      
                                        <div class="card" [ngClass]="standardshowTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="standardPlagiarism(2)" data-toggle="collapse" href="#standardcollapseTwo">
                                                    <span><img src="../../../../assets/images/plagiarism-check/sources.svg" alt="icon" /></span>
                                                    識別前個匹配來源
                                                </a>
                                            </div>
                                            <div id="standardcollapseTwo" class="collapse show" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>列出前個匹配的來源以及匹配百分比。</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="standardshowTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(3)" data-toggle="collapse" href="#standardcollapseThree">
                                                    <span><img src="../../../../assets/images/plagiarism-check/text-block.svg" alt="icon" /></span>
                                                    突出顯示匹配的文本
                                                </a>
                                            </div>
                                            <div id="standardcollapseThree" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>對於匹配的來源，報告會突出顯示確切的匹配文本。</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="standardshowTab == 4 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(4)" data-toggle="collapse" href="#standardcollapseFour">
                                                    <span><img src="../../../../assets/images/plagiarism-check/flag-2.svg" alt="icon" /></span>
                                                    標記隱藏內容
                                                </a>
                                            </div>
                                            <div id="standardcollapseFour" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>檢測並標記文檔中的隱藏文本和可疑字元。</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="standardshowTab == 5 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(5)" data-toggle="collapse" href="#standardcollapseFive">
                                                    <span><img src="../../../../assets/images/plagiarism-check/share_1.svg" alt="icon" /></span>
                                                    排除選擇的部分
                                                </a>
                                            </div>
                                            <div id="standardcollapseFive" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>提供排除文檔中選擇部分的靈活性。</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="c-card key-features-right">
                                    <div class="image video-feature" [ngClass]="standardshowTab == 1 ? 'show' : ''">
                                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="../../../assets/images/videos/posters/plagiarism-check.jpg">
                                            <source src="../../../../assets/images/plagiarism-check/AI-Content-Detector.mp4#t=0.1" type="video/mp4">
                                            Your browser does not support the video element. Kindly update it to latest version.
                                        </video>
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 2 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/sources.png" alt="paid publications" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 3 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/highlight.png" alt="paid publications" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 4 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/flags-hidden.png" alt="paid publications" class="flags hidden" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 5 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/eclude-choosen.png" alt="paid publications" class="exclude choosen" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="advancedPlagiarism" class="tab-pane">
                        <div class="pc-para">
                            <span>對比付費文章和互聯網資源檢查 <br/>
                                學術論文抄襲檢查工具推薦</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6">
                                <div class="c-card key-features-left">
                                    <div id="accordion" class="accordion">
                                        <div class="card" [ngClass]="showTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="advancePlagiarism(1)" data-toggle="collapse" href="#collapseOne">
                                                    <span><img src="../../../../assets/images/plagiarism-check/sources.svg" alt="icon" /></span>
                                                    識別前個匹配來源
                                                </a>
                                            </div>
                                            <div id="collapseOne" class="collapse show" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>列出前個匹配的來源以及匹配百分比。</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="showTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(2)" data-toggle="collapse" href="#collapseTwo">
                                                    <span><img src="../../../../assets/images/plagiarism-check/text-block.svg" alt="icon" /></span>
                                                    突出顯示匹配的文本
                                                </a>
                                            </div>
                                            <div id="collapseTwo" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>對於匹配的來源，報告會突出顯示確切的匹配文本。</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="showTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(3)" data-toggle="collapse" href="#collapseThree">
                                                    <span><img src="../../../../assets/images/plagiarism-check/flag-2.svg" alt="icon" /></span>
                                                    標記隱藏內容
                                                </a>
                                            </div>
                                            <div id="collapseThree" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>檢測並標記文檔中的隱藏文本和可疑字元。</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="showTab == 4 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(4)" data-toggle="collapse" href="#collapseFour">
                                                    <span><img src="../../../../assets/images/plagiarism-check/export.svg" alt="icon" /></span>
                                                    排除選擇的部分
                                                </a>
                                            </div>
                                            <div id="collapseFour" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>提供排除文檔中選擇部分的靈活性。</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="showTab == 5 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(5)" data-toggle="collapse" href="#collapseFive">
                                                    <span><img src="../../../../assets/images/plagiarism-check/share_1.svg" alt="icon" /></span>
                                                    提供分享選項
                                                </a>
                                            </div>
                                            <div id="collapseFive" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>提供多種選項，可無縫分享您的報告。</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 dflex">
                                <div class="c-card key-features-right">
                                    <div class="image" [ngClass]="showTab == 1 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/sources.png" alt="paid publications" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 2 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/highlight.png" alt="paid publications" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 3 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/flags-hidden.png" alt="paid publications" class="flags hidden" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 4 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/eclude-choosen.png" alt="paid publications" class="exclude choosen" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 5 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/share.png" alt="paid publications" class="share" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-lg standOut">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="section-tl">
                    <h2>Trinka抄襲檢測器的獨特之處是什麼？</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="standout-tbl">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Trinka & <br/> Enago Reports</th>
                                    <th class="grammarly">Grammarly</th>
                                    <th class="quillbot">Quillbot</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- <tr>
                                    <td>AI生成內容檢測器</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr> -->
                                <tr>
                                    <td>
                                        <p>
                                            iThenticate報告
                                            <span class="custom-tooltip">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M10 1.04164C14.9417 1.04165 18.9584 5.05831 18.9584 9.99998C18.9584 14.9416 14.9417 18.9583 10 18.9583C5.05837 18.9583 1.04171 14.9416 1.04171 9.99998C1.04171 5.05831 5.05838 1.04164 10 1.04164ZM10 17.7083C14.25 17.7083 17.7084 14.25 17.7084 9.99998C17.7084 5.74998 14.25 2.29165 10 2.29164C5.75004 2.29164 2.29171 5.74998 2.29171 9.99998C2.29171 14.25 5.75004 17.7083 10 17.7083Z" fill="#414E62"/>
                                                    <path d="M10 8.54165C10.3417 8.54165 10.625 8.82498 10.625 9.16665L10.625 13.3333C10.625 13.675 10.3417 13.9583 10 13.9583C9.65833 13.9583 9.375 13.675 9.375 13.3333L9.375 9.16665C9.375 8.82498 9.65833 8.54165 10 8.54165Z" fill="#414E62"/>
                                                    <path d="M10 5.83335C10.1084 5.83335 10.2167 5.85835 10.3167 5.90002C10.4167 5.94168 10.5084 6.00002 10.5917 6.07502C10.6667 6.15835 10.725 6.24168 10.7667 6.35002C10.8084 6.45002 10.8334 6.55835 10.8334 6.66668C10.8334 6.77502 10.8084 6.88335 10.7667 6.98335C10.725 7.08335 10.6667 7.17502 10.5917 7.25835C10.5084 7.33335 10.4167 7.39168 10.3167 7.43335C10.1167 7.51668 9.88337 7.51668 9.68337 7.43335C9.58337 7.39168 9.49171 7.33335 9.40837 7.25835C9.33337 7.17502 9.27504 7.08335 9.23337 6.98335C9.19171 6.88335 9.16671 6.77502 9.16671 6.66668C9.16671 6.55835 9.19171 6.45002 9.23337 6.35002C9.27504 6.24168 9.33337 6.15835 9.40837 6.07502C9.49171 6.00002 9.58337 5.94168 9.68337 5.90002C9.78337 5.85835 9.89171 5.83335 10 5.83335Z" fill="#414E62"/>
                                                </svg>
                                                <div class="custom-tooltip-content custom-tooltip-transform">
                                                    高級抄襲檢查提供
                                                </div>
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>
                                        <p>
                                            標準抄襲檢查
                                            <span class="custom-tooltip">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M10 1.04164C14.9417 1.04165 18.9584 5.05831 18.9584 9.99998C18.9584 14.9416 14.9417 18.9583 10 18.9583C5.05837 18.9583 1.04171 14.9416 1.04171 9.99998C1.04171 5.05831 5.05838 1.04164 10 1.04164ZM10 17.7083C14.25 17.7083 17.7084 14.25 17.7084 9.99998C17.7084 5.74998 14.25 2.29165 10 2.29164C5.75004 2.29164 2.29171 5.74998 2.29171 9.99998C2.29171 14.25 5.75004 17.7083 10 17.7083Z" fill="#414E62"/>
                                                    <path d="M10 8.54165C10.3417 8.54165 10.625 8.82498 10.625 9.16665L10.625 13.3333C10.625 13.675 10.3417 13.9583 10 13.9583C9.65833 13.9583 9.375 13.675 9.375 13.3333L9.375 9.16665C9.375 8.82498 9.65833 8.54165 10 8.54165Z" fill="#414E62"/>
                                                    <path d="M10 5.83335C10.1084 5.83335 10.2167 5.85835 10.3167 5.90002C10.4167 5.94168 10.5084 6.00002 10.5917 6.07502C10.6667 6.15835 10.725 6.24168 10.7667 6.35002C10.8084 6.45002 10.8334 6.55835 10.8334 6.66668C10.8334 6.77502 10.8084 6.88335 10.7667 6.98335C10.725 7.08335 10.6667 7.17502 10.5917 7.25835C10.5084 7.33335 10.4167 7.39168 10.3167 7.43335C10.1167 7.51668 9.88337 7.51668 9.68337 7.43335C9.58337 7.39168 9.49171 7.33335 9.40837 7.25835C9.33337 7.17502 9.27504 7.08335 9.23337 6.98335C9.19171 6.88335 9.16671 6.77502 9.16671 6.66668C9.16671 6.55835 9.19171 6.45002 9.23337 6.35002C9.27504 6.24168 9.33337 6.15835 9.40837 6.07502C9.49171 6.00002 9.58337 5.94168 9.68337 5.90002C9.78337 5.85835 9.89171 5.83335 10 5.83335Z" fill="#414E62"/>
                                                </svg>
                                                <div class="custom-tooltip-content custom-tooltip-transform">
                                                    標準抄襲檢查提供
                                                </div>
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>無限獲得相似度報告</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>每月20頁</td>
                                </tr>
                                <tr>
                                    <td>可下載的PDF報告</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="single-wrapper section-md">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="wrap-content">
                    <h3>使用Trinka每月獲得高達<span>2個免費的iThenticate</span>積分</h3>
                    <a href="https://cloud.trinka.ai/signup" class="btn-outline-enago" target="_blank">
                        <span>開始使用</span> <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path d="M12.5248 15.6833C12.3664 15.6833 12.2081 15.625 12.0831 15.5C11.8414 15.2583 11.8414 14.8583 12.0831 14.6166L16.6998 9.99998L12.0831 5.38331C11.8414 5.14164 11.8414 4.74164 12.0831 4.49998C12.3248 4.25831 12.7248 4.25831 12.9664 4.49998L18.0248 9.55831C18.2664 9.79998 18.2664 10.2 18.0248 10.4416L12.9664 15.5C12.8414 15.625 12.6831 15.6833 12.5248 15.6833Z" fill="black"/>
                            <path d="M17.4415 10.625H3.4165C3.07484 10.625 2.7915 10.3417 2.7915 10C2.7915 9.65833 3.07484 9.375 3.4165 9.375H17.4415C17.7832 9.375 18.0665 9.65833 18.0665 10C18.0665 10.3417 17.7832 10.625 17.4415 10.625Z" fill="black"/>
                          </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-lg">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-xl-5 col-md-12">
                <div class="section-tl">
                    <h2>涵蓋1700多個付費科學期刊</h2>
                    <div class="HeadingSubLine"></div>
                    <p>利用最準確的文本相似性檢測演算法來驗證內容的抄襲情況，以保持其完整性和可信度。將您的文稿與Elsevier、Wiley、Springer Nature、Taylor & Francis、Sage等眾多知名出版社發表的文章進行比較。</p>
                </div>
            </div>
            <div class="col-lg-6 col-xl-6 offset-xl-1  col-md-12">
                <div class="no-image">
                    <img src="../../../../assets/images/plagiarism-check/plagiarism-check-map.png" alt="plag check map" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-lg pt-0">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="section-tl">
                    <h2>使用Trinka的抄襲檢查獲得高品質的評估</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-xl-6 col-md-12">
                <div class="section-tl">
                    <p>由於存在多種抄襲檢測工具可供選擇，選擇合適的工具可能會具有挑戰性。為了讓您更輕鬆地完成此過程，我們比較了多種廣泛使用的抄襲檢測工具，結果顯示Trinka提供了最可靠和準確的結果。</p>
                    <p>在對高度抄襲的樣本論文進行測試時，Trinka抄襲檢測器的性能超過了大多數其他工具。</p>
                    <p>基於6個參數，我們比較了3個領先的工具的準確性、資料庫大小、可訪問性、易用性、成本和安全性。Trinka提供了一流的評估和專業知識，同時保護您的資料的安全。</p>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 offset-xl-1  col-md-12">
                <div class="no-image">
                    <img src="../../../../assets/images/plagiarism-check/plagiarism-check-graph.jpg" alt="plag check graph" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="suitableForSection section-lg" style="background-color: #F5F7F8;">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-tl">
                    <h2>為什麼選擇Trinka抄襲檢測器？</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <img src="../../../assets/images/languageScore_icon.svg" width="40" height="40" alt="ppc"/>
                    </div>
                    <div class="media-body">
                        <h4>每月免費提供抄襲檢查積分</h4>
                        <p>在生成報告之前，免費檢查您的內容是否存在抄襲。您的文檔將與互聯網、開放獲取和付費出版物比對，進行抄襲檢查。</p>
                    </div>
                </div>
            </div>
            <!-- <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <img src="../../../assets/images/plagiarism-check/ai-content-detector.svg" width="40" height="40" alt="ppc"/>
                    </div>
                    <div class="media-body">
                        <h4>AI生成內容檢測</h4>
                        <p>在檢查抄襲時，及時檢測來自ChatGPT、GPT-4、Bard、Bing Chat等大型語言模型（LLM）的AI生成文本，以維護內容的完整性。</p>
                    </div>
                </div>
            </div> -->
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <img src="../../../assets/images/plagiarism-check/standard-check.svg" width="40" height="40" alt="ppc"/>

                    </div>
                    <div class="media-body">
                        <h4>無限制標準抄襲檢查</h4>
                        <p>獲取無限制的標準抄襲檢查可將您的內容與互聯網來源和開放獲取出版物進行比較。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <img src="../../../assets/images/plagiarism-check/detection-technology.svg" width="40" height="40" alt="ppc"/>

                    </div>
                    <div class="media-body">
                        <h4>卓越的檢測技術</h4>
                        <p>我們的抄襲檢查器檢測技術得到了最大的學術出版商的應用，智慧排除已引用的內容，為您提供可靠的結果。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="allAboutTrinkaCredit">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="aboutTrinkaCreditHeading">
                    <h2>抄襲檢查使用積分</h2>
                    <div class="HeadingSubLine"></div>
                </div>
                <div class="creditSectionFeature">
                    <div class="othersPointsForCredits">
                        <p style="margin-bottom: 0px;">積分類似於代幣，可根據需要使用多種Trinka功能。</p>
                        <p>高級用戶每月獲得10個積分，基本用戶每月獲得4個免費積分。瞭解更多資訊，請<a [routerLink]="['/features/credits']">點擊此處</a>。</p>
                    </div>
                    <div class="featurePointsCredits">
                        <span>
                            <img src="../../../../assets/images/credits_icon.png" alt="credits">
                        </span>
                        <p>標準抄襲檢查需要使用12積分，而高級抄襲檢查需要使用18積分。<br />充分利用您每月的免費積分，僅在需要時購買更多。</p>
                    </div>
                    <div class="othersPointsForCredits">
                        <p style="margin-bottom: 0px;">Trinka高級用戶每月獲得2次免費的抄襲檢查。</p>
                        <p>此外，您還可享受高達6折的積分包購買折扣。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="section-lg bg-grey">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="section-tl">
                    <h2>如何使用</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="allPlans-wrapper">
                    <div class="plan-content plan-simple">
                        <div class="plan-header"></div>
                        <ul>
                            <li>免費點數</li>
                            <li>標準報告</li>
                            <li>進階報告</li>
                            <li>每月獲取新的積分 </li>
                            <!-- <li>Additional Credit Discounting / Purchase</li> -->
                            <li>批量購買積分的價格</li>
                        </ul>
                    </div>
                    <div class="plan-content plan-basic">
                        <div class="plan-header">
                            基本
                        </div>
                        <ul>
                            <li><span>每月<b>1個免費積分</b></span></li>
                            <li><span>使用<b>12積分</b></span></li>
                            <li><span>使用<b>18積分</b></span></li>
                            <li><span>每月<b>4個積分 </b></span></li>
                            <!-- <li><span><b>6 USD </b> per Extra Credit Purchase</span></li> -->
                            <li><span>每積分僅需<b class="d-inline"> 3美元</b><br/> （40個積分包）</span></li>
                        </ul>
                    </div>
                    <div class="plan-content plan-premium">
                        <div class="plan-header">
                            高級
                        </div>
                        <ul>
                            <li><span>每月<b>2個免費積分</b></span></li>
                            <li><span>使用<b>12積分 </b></span></li>
                            <li><span>使用<b>18積分</b></span></li>
                            <li><span>每月<b>10個積分</b></span></li>
                            <!-- <li><span><b>3.6 USD</b> per Extra Credit Purchase</span></li> -->
                            <li><span>每積分僅需<b class="d-inline">1.8美元</b><br/> （40個積分包）</span></li>
                        </ul>
                    </div>
                    <div class="plan-content plan-recommended">
                        <div class="plan-header">
                            Premium Plus
                            <span>Recommended</span>
                        </div>
                        <ul>
                            <li><span>每月<b>2個免費積分</b></span></li>
                            <li><span><b>無限訪問 </b></span></li>
                            <li><span>使用<b>18積分</b></span></li>
                            <li><span>每月<b>10個積分</b></span></li>
                            <!-- <li><span><b>3.6 USD </b> per Extra Credit Purchase</span></li> -->
                            <li><span>每積分僅需<b class="d-inline">1.8美元</b><br/> （40個積分包）</span></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="use_trinka_other_app accomplishBrilliantWrap">
    <div class="container">
        <div class="accomplishBrilliantSection">
            <h2>掃除抄襲疑雲，自信提交您的稿件</h2>
            <a href="https://cloud.trinka.ai/signup" target="_blank">開始使用</a>
        </div>
    </div>
</div>

<div class="pricingQuestionAnwser" #target>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="pricingHeadingQuestion">
                    <h2>常見問題</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <div class="pricingQuestionsList">
                    <div class="accordion" id="faq">
                        <div class="card">
                            <div class="card-header" id="QuestionOne">
                                <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                    Trinka的抄襲檢查是如何運作的？</a>
                            </div>

                            <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                <div class="card-body">
                                    <h4>非常簡單！</h4>
                                    <ol>
                                        <li>進入您的Trinka雲端帳戶（還沒有註冊免費帳戶？ <a href="https://cloud.trinka.ai/signup" target="_blank">現在就註冊!</a> )</li>
                                        <li>從右側面板上點擊導航到抄襲檢查頁面。</li>
                                        <li>上傳文件並選擇適合您的檢查。您也可以選擇一個您已經上傳到Trinka drive中的檔案。</li>
                                        <li>在幾分鐘內獲得詳細的報告!</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="QuestionTwo">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                    aria-controls="QuestionTwoContent">
                                    Trinka的抄襲檢查與其他的有什麼不同？</a>
                            </div>

                            <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                <div class="card-body">
                                    <p>與其他工具不同，Trinka讓您選擇符合您需求的抄襲檢查--網路內容或網路+付費出版物。我們在技術上與iThenticate合作，提供卓越的檢測能力，受到全球各大型學術出版商的信任。</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionThree">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                    aria-controls="QuestionThreeContent">
                                    我可以免費使用Trinka的抄襲檢查嗎？
                                </a>
                            </div>

                            <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                <div class="card-body">
                                    <!-- <p>Yes. All Basic users get 1 free Plagiarism Score every month. All Premium users get 2 free Plagiarism Score checks every month. You can run as many checks as you like with <a [routerLink]="['/features/credits']">credits</a>.</p> -->
                                    <p>您可以在Trinka上免費獲得查重分數!</p>
                                    <p>如果您有一個基本帳戶，您每個月可以得到1次免費的查重檢查。如果您有一個Trinka高級帳戶，您將每月獲得2次免費的查重檢查</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionFour">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                    aria-controls="QuestionFourContent">
                                    抄襲檢查報告可以下載嗎？
                                </a>
                            </div>

                            <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                <div class="card-body">
                                    <p>是的! 報告是PDF格式的，可以在您生成報告後的任何時候下載。</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-lg-1"></div>
        </div>
    </div>
</div>
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/Mc_EZXIzvFU"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>

<!-- The Modal -->
<div class="modal" id="freePlagiarismScore">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header bb-none">
          <h4 class="modal-title">Sample Score</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
  
        <!-- Modal body -->
        <div class="modal-body">
          <img src="../../../../assets/images/reports/report_list_item.png" class="img-fluid" />
        </div>
      </div>
    </div>
</div>